import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface ClientTableHeaderProps {
  partnerName: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function ClientTableHeader({
  partnerName,
  searchTerm,
  onSearchChange,
}: ClientTableHeaderProps) {
  return (
    <div className="space-y-4 gap-2 lg:space-y-0 lg:flex lg:items-center lg:justify-between">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold leading-6 text-gray-900 sm:text-xl lg:text-2xl">
          {partnerName}
        </h2>
        <p className="text-sm text-muted-foreground sm:text-base max-w-2xl">
          Gerencie clientes vinculados. O link de criação de senha expira em 24h. É possível
          reenviar o convite a qualquer momento.
        </p>
      </div>
      <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 lg:flex-shrink-0">
        <div className="relative flex-1 sm:flex-none sm:w-64 lg:w-72">
          <Input
            placeholder="Procurar clientes..."
            value={searchTerm}
            className="w-full h-10 sm:h-9"
            iconLeft={<Search className="h-4 w-4 stroke-muted-foreground" />}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
